var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": _vm.maxWith, persistent: _vm.persistent },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-row",
            {
              staticClass:
                "modal-title white--text d-flex align-center px-2 py-4",
              attrs: { "no-gutters": "" }
            },
            [
              _c("v-col", { attrs: { cols: "11" } }, [
                _c(
                  "h3",
                  { staticClass: "d-flex align-center font-weight-regular" },
                  [
                    _c("v-icon", { staticClass: "mr-2", attrs: { dark: "" } }, [
                      _vm._v(_vm._s(_vm.icon))
                    ]),
                    _vm._t("icon"),
                    _vm._v(" " + _vm._s(_vm.title) + " ")
                  ],
                  2
                )
              ]),
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-row-reverse",
                  attrs: { cols: "1" }
                },
                [
                  _c(
                    "icon-button",
                    {
                      attrs: { title: "Cerrar" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return (function() {
                            return _vm.closeModal()
                          })($event)
                        }
                      }
                    },
                    [_vm._v(" mdi-close ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }